import types from './types';
import employeeDashboardTypes from '../../Home/MySchedule/duck/types';
import _ from 'lodash';

const initialState = {
  meta: {
    fetchingTimeOffRequests: false,
    timeOffRequestNetworkAction: false
  },
  all: [],
  byEmployeeId: {}
};

export const timeOffRequestReducers = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_TIME_OFF_REQUESTS_REQUEST: {
      return {
        ...state,
        meta: {
          ...state.meta,
          fetchingTimeOffRequests: true
        }
      };
    }
    case types.GET_TIME_OFF_REQUESTS_SUCCESS: {
      return {
        ...state,
        meta: {
          ...state.meta,
          fetchingTimeOffRequests: false
        },
        all: [...action.requests],
        byEmployeeId: action.groupedByEmployeeId
      };
    }
    case types.GET_TIME_OFF_REQUESTS_FAILURE: {
      return {
        ...state,
        meta: {
          ...state.meta,
          fetchingTimeOffRequests: false
        }
      };
    }
    case types.UPDATE_TIME_OFF_REQUEST_STATUS_SUCCESS: {
      let allRequestsCopy = [...state.all];
      let byEmployeeIdRequestsCopy = { ...state.byEmployeeId };
      action.requests.forEach(req => {
        let requestToUpdate = allRequestsCopy.find(el => el.id === req.id);
        const requestToUpdateIndex = allRequestsCopy.findIndex(el => el.id === req.id);
        const { employeeId } = requestToUpdate;
        const indexToUpdateInEmployeeObject = byEmployeeIdRequestsCopy[employeeId].findIndex(el => el.id === req.id);

        // update values in redux
        if (requestToUpdate.status) {
          requestToUpdate.status.status = req.status;
          requestToUpdate.status.hoursApproved = req.hoursApproved;
        } else {
          requestToUpdate['status'] = {
            status: req.status,
            hoursApproved: req.hoursApproved
          };
        }

        allRequestsCopy[requestToUpdateIndex] = requestToUpdate;
        byEmployeeIdRequestsCopy[employeeId][indexToUpdateInEmployeeObject] = requestToUpdate;
      });

      return {
        ...state,
        all: allRequestsCopy,
        byEmployeeId: byEmployeeIdRequestsCopy
      };
    }
    case employeeDashboardTypes.REQUEST_TIME_OFF_SUCCESS: {
      const { timeOffRequest } = action;
      const { employeeId } = timeOffRequest;
      let allRequestsCopy = [...state.all];
      let byEmployeeIdRequestsCopy = { ...state.byEmployeeId };

      allRequestsCopy.push(timeOffRequest);

      if (byEmployeeIdRequestsCopy[parseInt(employeeId, 10)]) {
        byEmployeeIdRequestsCopy[parseInt(employeeId, 10)].push(timeOffRequest);
      } else {
        byEmployeeIdRequestsCopy[parseInt(employeeId, 10)] = [timeOffRequest];
      }

      return {
        ...state,
        all: allRequestsCopy,
        byEmployeeId: byEmployeeIdRequestsCopy
      };
    }
    case types.EDIT_TIME_OFF_REQUEST_SUCCESS: {
      const { id, requestType, timeOffType, start, end, description } = action;
      let allRequestsCopy = [...state.all];
      let byEmployeeIdRequestsCopy = { ...state.byEmployeeId };

      // update existing value in redux //
      // use first result since there should only be one since ids are unique
      let ids = allRequestsCopy.map(req => req.id);
      let indexToUpdate = ids.indexOf(id);
      let requestToEdit = allRequestsCopy[indexToUpdate];
      const { employeeId } = requestToEdit;

      requestToEdit = {
        ...requestToEdit,
        description,
        end,
        start,
        allDay: requestType === 'allDay',
        type: timeOffType
      };

      allRequestsCopy[indexToUpdate] = requestToEdit;

      byEmployeeIdRequestsCopy = {
        ...byEmployeeIdRequestsCopy,
        [employeeId]: byEmployeeIdRequestsCopy[employeeId].map(req => {
          return req.id === id ? requestToEdit : req;
        })
      };

      return {
        ...state,
        all: allRequestsCopy,
        byEmployeeId: byEmployeeIdRequestsCopy
      };
    }
    case types.ARCHIVE_TIME_OFF_REQUEST_SUCCESS: {
      const { ids } = action;
      let allRequestsCopy = [...state.all];

      _.remove(allRequestsCopy, req => ids.includes(req.id));

      return {
        ...state,
        all: allRequestsCopy
      };
    }
    case types.MANAGER_CREATE_EMPLOYEE_TIME_OFF_REQUEST_REQUEST: {
      return {
        ...state,
        meta: {
          ...state.meta,
          timeOffRequestNetworkAction: true
        }
      };
    }
    case types.MANAGER_CREATE_EMPLOYEE_TIME_OFF_REQUEST_SUCCESS: {
      const allRequestsCopy = [...state.all];
      const byEmployeeIdRequestsCopy = { ...state.byEmployeeId };

      allRequestsCopy.push(action.request);

      if (byEmployeeIdRequestsCopy[action.request.employeeId]) {
        byEmployeeIdRequestsCopy[action.request.employeeId].push(action.request);
      } else {
        byEmployeeIdRequestsCopy[action.request.employeeId] = [action.request];
      }

      return {
        ...state,
        meta: {
          ...state.meta,
          timeOffRequestNetworkAction: false
        },
        all: allRequestsCopy,
        byEmployeeId: byEmployeeIdRequestsCopy
      };
    }
    case types.MANAGER_CREATE_EMPLOYEE_TIME_OFF_REQUEST_FAILURE: {
      return {
        ...state,
        meta: {
          ...state.meta,
          timeOffRequestNetworkAction: false
        }
      };
    }
    default:
      return state;
  }
};
